import { Grid } from '@mantine/core';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './styles.scoped.css';
import classNames from '../../../utils/classNames';

export default function GridCell({ label, data, right = 6, left = 6, className, center }) {
  const classes = classNames('data', className);
  return (
    <Grid align={center ? 'center' : 'flex-start'}>
      <Grid.Col span={left}>
        <div className={styles.label}>{label}</div>
      </Grid.Col>
      <Grid.Col span={right}>
        <div className={classes}>
          {typeof data === 'string' ? `: ${data}` : data}
        </div>
      </Grid.Col>
    </Grid>
  );
}

GridCell.propTypes = {
  center: PropTypes.bool,
  className: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  label: PropTypes.string,
  left: PropTypes.number,
  right: PropTypes.number
};
